import { terminalOrderStatus } from './orderStatus';

export function tableLabel(value) {
  const name = String(value || '').trim();
  return !name || name === 'No table' ? 'No table' : /^table(?:\s|$)/i.test(name) ? name : `Table ${name}`;
}

export function orderMinutes(order, now = Date.now()) {
  const minutes = order.created_at ? Math.floor((now - new Date(order.created_at).getTime()) / 60000) : order.minutes;
  return Number.isFinite(minutes) ? Math.max(0, minutes) : null;
}

export function orderAgeColour(order, now) {
  if (terminalOrderStatus(order.status)) return 'gray';
  const minutes = orderMinutes(order, now);
  return minutes >= 20 ? 'red' : minutes >= 10 ? 'amber' : 'gray';
}

function amount(value) {
  const match = /^(-?)(\d+)(?:\.(\d{1,2}))? ([A-Z]{3})$/.exec(String(value || ''));
  return match ? { cents: (match[1] ? -1 : 1) * (Number(match[2]) * 100 + Number((match[3] || '').padEnd(2, '0'))), currency: match[4] } : null;
}

export function paymentStatus(order) {
  const total = amount(order.total);
  const payments = (order.payments || []).map(payment => amount(payment.amount));
  if (!total || payments.some(payment => !payment || payment.currency !== total.currency)) {
    return { label: 'Check payment', colour: 'gray' };
  }
  const paid = payments.reduce((sum, payment) => sum + payment.cents, 0);
  if (paid >= total.cents) return { label: 'Paid', colour: 'green' };
  return paid > 0 ? { label: 'Part paid', colour: 'amber' } : { label: 'Unpaid', colour: 'red' };
}


export function orderReference(order) {
  return [order?.pos_ref,order?.collection_code,order?.ref,order?.id].find(value=>typeof value==='string'&&value.trim())?.trim()||'—';
}
